import CityPageTemplate from "../city-template/CityPageTemplate";
import { shorelineConfig } from "./data";

export default function ShorelinePage() {
  return <CityPageTemplate config={shorelineConfig} />;
}